export const ESTADO_COBRO = {
  NO_COBRADO: 0,
  COBRADO: 1,
  PARCIALMENTE_COBRADO: 2,
} as const

export type EstadoCobroType = (typeof ESTADO_COBRO)[keyof typeof ESTADO_COBRO]
